import { nmService as e } from "./NmService.js";
const m = {
  nm: e
};
export {
  m as services
};
